import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
const state = {
    informationsParcours: {
        email: null,
        partageEmail: false,
        objectifsDuProjet: [],
        diplomeChoisi: {},
        situation: null,
        possedeExperienceProche: false,
        experienceProche: '',
        possedeDiplomeProche: false,
        diplomeProche: '',
        competencesTransversales: {},
        activitesQuotidiennes: [],
        maniereApprendre: '',
        deroulementsFormations: [],
        informationsComplementaires: [],
        domaineFormation: {
            code: '',
            libelle: ''
        },
        typeFormation: {
            code: '',
            libelle: ''
        }
    }
};
const getters = {
    getInformationsParcours: (state) => {
        return state.informationsParcours;
    },
    getCompetencesTansversales: (state) => {
        return state.informationsParcours.competencesTransversales;
    }
};
const mutations = {
    setExperienceEtDiplome: (state, {possedeExperienceProche, experienceProche, possedeDiplomeProche, diplomeProche}) => {
        state.informationsParcours.possedeExperienceProche = possedeExperienceProche;
        state.informationsParcours.experienceProche = experienceProche;
        state.informationsParcours.possedeDiplomeProche = possedeDiplomeProche;
        state.informationsParcours.diplomeProche = diplomeProche;
    },
    setDiplomeChoisi: (state, diplomeChoisi) => {
        state.informationsParcours.diplomeChoisi = diplomeChoisi;
    },
    setSituation: (state, situation) => {
        state.informationsParcours.situation = situation;
    },
    setObjectifsDuProjet: (state, objectifsDuProjet) => {
        state.informationsParcours.objectifsDuProjet = objectifsDuProjet;
    },
    setActivitesQuotidiennes: (state, activitesQuotidiennes) => {
        state.informationsParcours.activitesQuotidiennes = activitesQuotidiennes;
    },
    setManiereApprendre: (state, maniereApprendre) => {
        state.informationsParcours.maniereApprendre = maniereApprendre;
    },
    setInformationsComplementaires: (state, informationsComplementaires) => {
        state.informationsParcours.informationsComplementaires = informationsComplementaires;
    },
    setDeroulementsFormations: (state, deroulementsFormations) => {
        state.informationsParcours.deroulementsFormations = deroulementsFormations;
    },
    setCompetencesTransversales: (state, competencesTransversales) => {
        state.informationsParcours.competencesTransversales = competencesTransversales;
    },
    setEmail: (state, email) => {
        state.informationsParcours.email = email;
    },
    setPartageEmail: (state, partageEmail) => {
        state.informationsParcours.partageEmail = partageEmail;
    },
    setDomaineFormation: (state, domaineFormation) => {
        state.informationsParcours.domaineFormation = domaineFormation;
    },
    setTypeFormation: (state, typeFormation) => {
        state.informationsParcours.typeFormation = typeFormation;
    }
};
export default new Vuex.Store({
    state,
    getters,
    mutations,
    strict: debug
});
